import Splide from "@splidejs/splide";
import { Grid } from "@splidejs/splide-extension-grid";
import '@splidejs/splide/css/core';


export const logotypesSlider = () => {
  const target = document.querySelectorAll(".splide.logotypes-slider");
  if (target === null) return;
  Array.from(target).forEach((slider: HTMLElement) => {
    new Splide(slider, {
      type: "slide",
      rewind: true,
      perPage: 1,
      perMove: 1,
      pagination: false,
      grid: {
        gap: {
          row: '2rem',
          col: '3rem',
        },
      }
    }).mount({ Grid });
  });
}; 
